module.exports = __webpack_public_path__ + "static/media/WarningCircle.3dabbcff.svg";